import { useCallback } from 'react';
import { donateShortcut } from 'utils/packages/siriShortcut';
import { logAnalyticsEvent } from 'utils/packages/rnFirebase';
import Amplitude from 'utils/amplitude';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectIsGBUser } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { subscriptionsActivityType } from '../../../../constants';
const useSeeAllSubscriptions = () => {
    const nav = useMainStackNavigation();
    const { navigateToTab } = useTabNavigation();
    const isGBUser = useAppSelector(selectIsGBUser);
    const onPressSeeAll = useCallback(() => {
        Amplitude.logEvent('Feed.Subscriptions');
        logAnalyticsEvent('Open_All_Subscriptions');
        const opts = {
            activityType: subscriptionsActivityType, // This activity type needs to be set in `NSUserActivityTypes` on the Info.plist
            title: 'View Recurring Payments',
            keywords: ['Subscriptions', 'Recurring Payments', 'Bills'],
            persistentIdentifier: subscriptionsActivityType,
            isEligibleForSearch: true,
            isEligibleForPrediction: true,
            suggestedInvocationPhrase: 'View Recurring Payments',
        };
        donateShortcut(opts);
        if (isGBUser) {
            nav.navigateDeprecated('Subscriptions');
        }
        else {
            navigateToTab('RecurringTab');
        }
    }, [isGBUser, nav, navigateToTab]);
    return onPressSeeAll;
};
export default useSeeAllSubscriptions;
